import axios from "axios";
import { Config } from "../../data/config";

export const SET_BEANID = "SET_BEANID";
export const setBeanid = payload => {
  return { type: SET_BEANID, payload };
};

export function getBeanid(bid)
{
  return function(dispatch) {
    axios
      .get(`${Config.frontApiUrl}/onboarding/beanid/${bid}`)
      .then(response => {
        dispatch(setBeanid(response.data));
      });
  };
}


// WEBPACK FOOTER //
// ./src/store/actions/beanid.js